import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import { complexDigitToman, faDigits } from "../../../tools/tools";
import { useReport } from "../../../tools/api";
import PieChart from "./PieChart/PieChart";

export const SALE_SERIES = [
	{ key: "spPurchaseSales", label: "سیم‌کارت", color: "#E64225" },
	{ key: "packageSales", label: "بسته", color: "#37B399" },
	{ key: "chargeSales", label: "شارژ", color: "#61AAFF" },
];

const SaleStatistics = () => {
	const { statisticalReportProductCommissionSales } = useReport();
	const [commission, setCommission] = useState(null);
	const [active, setActive] = useState(null); // hovered slice / row

	useEffect(() => {
		const initialServ = async () => {
			const res = await statisticalReportProductCommissionSales();
			setCommission(res && !res.HasError ? res.Result : {});
		};
		initialServ();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const series = SALE_SERIES.map((s) => ({ ...s, value: Math.abs(commission?.[s.key] || 0) }));
	const total = series.reduce((sum, s) => sum + s.value, 0);
	const share = (v) => (total ? Math.round((v / total) * 100) : 0);
	// a small but real share (e.g. 0.36%) must not read as 0%
	const shareText = (v) => (v > 0 && share(v) < 1 ? "کمتر از ۱٪" : `${faDigits(share(v))}٪`);
	// with nothing hovered the centre shows the biggest seller
	const shown = series[active ?? series.reduce((best, s, i) => (s.value > series[best].value ? i : best), 0)];

	return (
		<section className="dash-card dash-sales" aria-labelledby="sales-title">
			<header className="dash-card-head">
				<h2 id="sales-title">مجموع فروش</h2>
			</header>
			{!commission ? (
				<Skeleton active paragraph={{ rows: 4 }} title={false} />
			) : (
				<>
					<p className="sales-total">
						<span dir="ltr">{complexDigitToman(total)}</span> تومان
					</p>
					<div className="sales-body">
						<ul className="sales-rows">
							{series.map((s, i) => (
								<li key={s.key} className={active === i ? "is-active" : undefined} onMouseEnter={() => setActive(i)} onMouseLeave={() => setActive(null)}>
									<span className="sales-dot" style={{ background: s.color }} aria-hidden="true" />
									<span className="sales-label">{s.label}</span>
									<span className="sales-value">
										<span dir="ltr">{complexDigitToman(s.value)}</span> تومان
									</span>
									<span className="sales-share">{shareText(s.value)}</span>
								</li>
							))}
						</ul>
						{total > 0 && (
							<div className="sales-chart">
								<PieChart series={series} active={active} onActive={setActive}>
									<strong style={{ color: shown.color }}>{shareText(shown.value)}</strong>
									<span>{shown.label}</span>
								</PieChart>
							</div>
						)}
					</div>
				</>
			)}
		</section>
	);
};

export default SaleStatistics;
